import { CardWrapperContent } from './CardWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const CardWrapperPreview = ({
  children
}) => {
  return /*#__PURE__*/_jsx(CardWrapperContent, {
    children: children
  });
};
export { CardWrapperPreview };